import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importMarketplaceCardApplicationContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "MarketplaceCardApplicationContainer" */
                '@perpay-web/fintech/components/containers/MarketplaceCardApplicationContainer'
            ),
    );
